export default __webpack_public_path__ + "static/icomoon-ed73ed6593922f641eb7fa6bc7070789.svg";